import * as React from 'react'
import classNames from 'classnames'

import { ErrorIcon } from './icons/ErrorIcon'
import { ExclamationIcon } from './icons/ExclamationIcon'
import { useSearchParams } from 'react-router-dom'

export enum StateType {
  NO_PASSAGES = 'no_passages',
  ERROR = 'error',
  DETOUR = 'detour',
  WARNING = 'warning',
}

export default function StateScreen({ type }: { type: StateType }) {
  const [searchParams] = useSearchParams()
  const debug = searchParams.get('debug')
  const state = searchParams.get('state') as StateType
  const stateType = debug && state ? state : type

  const textClasses = classNames(
    'font-flanders font-medium whitespace-pre-line text-[64px] text-center',
    {
      'text-neutral-200': [
        StateType.NO_PASSAGES,
        StateType.ERROR,
        StateType.DETOUR,
      ].includes(stateType),
      'text-[#F1A30E]': stateType === StateType.WARNING,
    },
  )

  const text =
    {
      no_passages: 'De komende tijd zijn er geen \nvertrekken.',
      warning:
        'Dit is een noodbericht: Gelieve het \nstation onmiddellijk te verlaten.',
      error: 'Dit scherm is buiten dienst. \nOnze excuses, we werken eraan!',
      detour: 'Deze halte wordt niet bediend \nwegens een omleiding.',
    }[stateType] || 'Dit is een test.'

  return (
    <div className="flex-1 flex flex-col gap-10 bg-primary-grey justify-center items-center">
      <span aria-hidden="true">
        {stateType === StateType.ERROR && <ErrorIcon />}
        {stateType === StateType.WARNING && <ExclamationIcon color="yellow" />}
        {stateType === StateType.DETOUR && <ExclamationIcon color="red" />}
      </span>
      <div className={textClasses}>{text}</div>
    </div>
  )
}
